module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_studio-826312d1c33ba1ee57cb4681a4f9a611.webp";